export function isUnverifiedOverall(category = "") {
  return /^best\s*sellers?\s*rank$/i.test(category.trim());
}
export function selectRanking(entries) {
  const valid = entries.filter(entry => !isUnverifiedOverall(entry.category) && Number.isFinite(entry.rank) && entry.rank > 0);
  const newest = [...valid].sort((a, b) => new Date(b.retrieved_at) - new Date(a.retrieved_at));
  if (!newest.length) return null;
  const latest = new Date(newest[0].retrieved_at).getTime();
  const overall = newest.find(entry => /^(?:best sellers rank \((?:books|kindle store)\)|books|kindle store)$/i.test(entry.category) && latest - new Date(entry.retrieved_at).getTime() <= 2000);
  const chosen = overall || newest[0];
  return { ...chosen, label: overall ? (/kindle/i.test(chosen.category) ? "Best Sellers Rank (Kindle Store)" : "Best Sellers Rank (Books)") : `Category Rank: ${chosen.category}` };
}
